module.exports = __webpack_public_path__ + "img/02.3b0e1e59.png";